module.exports = __webpack_public_path__ + "static/media/Event-Carousels-FnB.08939d8e.webp";